<div class="info-window-container" *ngIf="showIcon">
  <ion-icon 
    name="information-circle-outline" 
    (click)="showInfoPopover($event)"
    class="info-icon">
  </ion-icon>
</div>

<div class="info-popover" *ngIf="!showIcon && showInfoBoxOutside">
  <h2 *ngIf="infoTitle">{{ infoTitle }}</h2>
  <div [innerHTML]="infoText" *ngIf="infoText"></div>
  <div [innerHTML]="customHtml" *ngIf="customHtml"></div>
</div>

<!-- Modern Info Modal -->
<ion-modal [isOpen]="showInfoModal" (didDismiss)="closeModal()" class="info-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-title *ngIf="!!infoTitle && infoTitle.length !== mainTitle.length">{{ infoTitle }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button (click)="closeModal()" fill="clear">
                        <ion-icon name="close" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <div class="info-content">
                <!-- Option 1: Custom HTML -->
                <div [innerHTML]="customHtml" *ngIf="customHtml"></div>
                
                <!-- Option 2: Structured Content -->
                <div *ngIf="!customHtml">
                    <h2 class="ion-margin-bottom" *ngIf="mainTitle">{{ mainTitle }}</h2>
                    <p *ngIf="mainText">{{ mainText }}</p>
                    <p *ngIf="infoText && !mainText">{{ infoText }}</p>
                    
                    <ion-list lines="none" *ngIf="items && items.length">
                        <ion-item *ngFor="let item of items">
                            <ion-label class="ion-text-wrap">
                                <h3 *ngIf="item.subTitle">{{ item.subTitle }}</h3>
                                <p *ngIf="item.subText">{{ item.subText }}</p>
                                <ul *ngIf="item.subList && item.subList.length">
                                    <li *ngFor="let listItem of item.subList">{{ listItem }}</li>
                                </ul>
                                <p *ngIf="item.subFooter">{{ item.subFooter }}</p>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                    
                    <p *ngIf="mainFooter">{{ mainFooter }}</p>
                </div>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>